import React, { useState, useContext } from "react"
import { v4 as uuidv4 } from "uuid"
import { useMutation } from "@apollo/client"

// Context
import { UserContext } from "../../../../context/userContext"

//gsql queries
import { ADD_USER } from "../queries"

//RefEntity user form
import ReferralEntityUserForm from "./Form/ReferralEntityUserForm"

//Referral API
import { referralsApiUserAddPost } from "../../partnerAPI"
import { LogError } from "../../../../helpers/logger"

export default function ReferralEntityUserAdd({
  onCancel,
  onSubmit,
  partnerOrganizationId,
}) {
  const userCtx = useContext(UserContext)

  const organizationId = !!partnerOrganizationId
    ? partnerOrganizationId
    : userCtx.session.user.organization_id

  const [isLoading, setIsLoading] = useState(false)
  const [formId, setFormId] = useState(() => uuidv4())
  const [userProfile, setUserProfile] = useState({
    admin_staff_id: userCtx.session.user.staff_id,
    admin_staff_alias: userCtx.session.user.staff_alias,
    admin_staff_enterprise_id: userCtx.session.user.enterprise_id,
    admin_staff_organization_id: userCtx.session.user.organization_id,
    admin_staff_enterprise_alias: userCtx.session.user.enterprise_alias,
    admin_staff_organization_alias: userCtx.session.user.organization_alias,
    staff_user_status: "ACTIVE",
    staff_id: "",
    staff_name_first: "",
    staff_name_last: "",
    staff_email_address: "",
    staff_password: "",
    staff_country: "",
    staff_zip_code: "",
    staff_address: "",
    staff_city: "",
    staff_state: "",
    staff_phone_telerecovery: "",
    staff_credentials: "",
    staff_organization_id: organizationId,
    staff_role: undefined,
    isPractitioner: false,
    practitionerNpi: undefined,
    locations: [],
    practitionerLocations: [],
    practitionerRoleType: undefined,
    practitionerReferralCategories: [],
  })

  const [addUser] = useMutation(ADD_USER, {
    variables: {
      organization_id: 0,
    },
  })

  async function processUser(submitProfile) {
    if (submitProfile !== null) {
      setIsLoading(true)
      try {

        submitProfile.variables.form_id = formId
        const result = await addUser(submitProfile)

        if (
          !!result.data &&
          result.data?.addUser !== null &&
          !!result.data?.addUser?.staff_id
        ) {
          //Convert service selections for tree select
          const selectedServices = !!submitProfile.variables
            .practitionerReferralCategories
            ? submitProfile?.variables?.practitionerReferralCategories
            : []

          let serviceSelection = []
          Object.keys(selectedServices).forEach((key) => {
            if (selectedServices[key].checked) {
              serviceSelection = [...serviceSelection, { Id: key, Name: "_" }]
            }
          })

          const apiResult = await referralsApiUserAddPost(
            userCtx.tokens.getMainToken(),
            organizationId,
            {
              processingUserId: userCtx.session.user.staff_id,
              processingOrganizationId: userCtx.session.user.organization_id,
              isNewUser: result.data.addUser.isNewUser,
              uid: result.data.addUser.staff_id,
              email: submitProfile.variables.staff_email_address,
              firstName: submitProfile.variables.staff_name_first,
              lastName: submitProfile.variables.staff_name_last,
              isPractitioner: submitProfile.variables.isPractitioner,
              practitionerNpi: submitProfile.variables.practitionerNpi,
              practitionerLocations:
                submitProfile.variables.practitionerLocations.map((x) => {
                  return {
                    name: x.name,
                    referralLocationId: x.referralLocationId,
                  }
                }),
              practitionerRoleTypes: [
                { id: submitProfile.variables.practitionerRoleType },
              ],
              practitionerReferralCategories: serviceSelection,
            },
          )

          if (apiResult?.isNewUser === false) {
            userCtx.setNotificationInformation(
              "The staff profile was already allocated to this partner",
            )
          }

          onSubmit(apiResult?.userProfile)
          setFormId(uuidv4())
        } else if (result.data?.addUser?.staff_id === null) {
          userCtx.setNotificationError(
            "The staff profile has already been added to this organization",
          )
          setIsLoading(false)
          return false
        } else {
          userCtx.setNotificationError(
            "There was an unexpected error while creating the user, please contact the administrator",
          )
          setIsLoading(false)
          return false
        }
      } catch (error) {
        let message =
          "An unexpected error occurred while creating the user, see console for more detail"

        if (!!error.isAxiosError) {
          message = `An unexpected error occurred while creating the user: ${error.response.data}`
        }

        userCtx.setNotificationError(message)
        LogError(message, error)
        setIsLoading(false)
        return false
      }
    }
  }

  return (
    <div>
      <ReferralEntityUserForm
        isInitialLoad={false}
        isLoading={isLoading}
        userProfile={userProfile}
        handleFormSubmit={async (values) => {
          setIsLoading(true)
          setUserProfile(values.variables)
          return await processUser(values)
        }}
        handleCancel={onCancel}
        partnerOrganizationId={organizationId}
      />
    </div>
  )
}
